import React from 'react';

interface TermHighlighterProps {
  strongTerms: string[];
  deadWeightTerms: string[];
  conflictingGenres: [string, string][];
  conflictingVocals: [string, string][];
}

export function TermHighlighter({ strongTerms, deadWeightTerms, conflictingGenres, conflictingVocals }: TermHighlighterProps): React.ReactElement | null {
  const hasContent = strongTerms.length > 0 || deadWeightTerms.length > 0 || conflictingGenres.length > 0 || conflictingVocals.length > 0;
  if (!hasContent) return null;

  return (
    <div className="space-y-3 pt-2">
      {strongTerms.length > 0 && (
        <div>
          <p className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest mb-1.5">Strong Signals</p>
          <div className="flex flex-wrap gap-1.5">
            {strongTerms.map(t => (
              <span key={t} className="px-2 py-0.5 text-[11px] font-mono bg-emerald-500/15 text-emerald-400 rounded-md border border-emerald-500/20">
                {t}
              </span>
            ))}
          </div>
        </div>
      )}

      {deadWeightTerms.length > 0 && (
        <div>
          <p className="text-[10px] font-bold text-red-500 uppercase tracking-widest mb-1.5">Dead Weight</p>
          <div className="flex flex-wrap gap-1.5">
            {deadWeightTerms.map(t => (
              <span key={t} className="px-2 py-0.5 text-[11px] font-mono bg-red-500/15 text-red-400 rounded-md border border-red-500/20 line-through">
                {t}
              </span>
            ))}
          </div>
        </div>
      )}

      {conflictingGenres.length > 0 && (
        <div>
          <p className="text-[10px] font-bold text-amber-500 uppercase tracking-widest mb-1.5">Genre Conflicts</p>
          <div className="flex flex-wrap gap-1.5">
            {conflictingGenres.map(([a, b], i) => (
              <span key={i} className="px-2 py-0.5 text-[11px] font-mono bg-amber-500/15 text-amber-400 rounded-md border border-amber-500/20">
                {a} <span className="text-slate-500">vs</span> {b}
              </span>
            ))}
          </div>
        </div>
      )}

      {conflictingVocals.length > 0 && (
        <div>
          <p className="text-[10px] font-bold text-amber-500 uppercase tracking-widest mb-1.5">Vocal Conflicts</p>
          <div className="flex flex-wrap gap-1.5">
            {conflictingVocals.map(([a, b], i) => (
              <span key={i} className="px-2 py-0.5 text-[11px] font-mono bg-amber-500/15 text-amber-400 rounded-md border border-amber-500/20">
                {a} <span className="text-slate-500">vs</span> {b}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
